// extracted by mini-css-extract-plugin
export var orderDetails = "_sn-2";
export var orderImage = "_sn-1";
export var orderMeta = "_sn-3";
export var orderSummary = "_sn-0";
export var rightArrow = "_sn-4";